import React, { useState } from "react"
import { useNavigate } from "react-router-dom"
import PropTypes from "prop-types"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"
// Components
import { SearchOutlined } from "@mui/icons-material"
// Styles
import {
   Container,
   Image,
   Title,
   Colors,
   Price,
   StyledLink,
   Icon,
   MobileIcon,
} from "./Product.styles"

const Product = ({ product, endingPoint, index }) => {
   const { t } = useTranslation()
   const user = useSelector((state) => state.user.currentUser)
   const displayPrices = useSelector((state) => state.environment.prices)
   const navigate = useNavigate()

   const [imageNumber, setImageNumber] = useState(0)
   const variationNumber = product.variations.findIndex(
      (item) => item._id === (product.idColor ? product.idColor : "")
   )

   const unitPrice = product.prices.find(
      (item) => item.userType === (user?.type ? user.type : "public")
   ).price

   const randomImageNumber = Math.floor(Math.random() * 4)

   const safeVariation = product.idColor
      ? product.variations[variationNumber]
      : product.variations.length > 1
      ? product.variations[randomImageNumber]
      : product.variations[0]

   const changeImageNumber = (e, mvt) => {
      e.preventDefault()
      if (mvt === "leave") {
         setImageNumber(0)
      } else if (product.variations[0].imagesLight.length > 1) {
         setImageNumber(1)
      } else {
         setImageNumber(0)
      }
   }

   return (
      <Container
         tabIndex={index}
         onMouseEnter={(e) => changeImageNumber(e, "enter")}
         onMouseLeave={(e) => changeImageNumber(e, "leave")}
      >
         <Image src={safeVariation?.imagesLight?.[imageNumber]} />
         <StyledLink
            to={`/product/${product._id}/${
               product.idColor ? product.idColor : product.variations[0]?._id
            }`}
         >
            <Icon>
               <MobileIcon
                  tabIndex={-1}
                  onMouseDown={(e) => e.preventDefault()}
               >
                  <SearchOutlined
                     fontSize="large"
                     onClick={(e) => {
                        e.preventDefault()
                        e.stopPropagation()
                        navigate(
                           `/product/${product._id}/${
                              product.idColor
                                 ? product.idColor
                                 : product.variations[0]._id
                           }`
                        )
                     }}
                  />
               </MobileIcon>
            </Icon>
         </StyledLink>
         <Title>{product.title}</Title>
         {(product.categories[0] !== "optical" || user?.type !== "public") &&
         displayPrices ? (
            <Price>{unitPrice}€</Price>
         ) : (
            <></>
         )}
         <Colors>
            {product.variations.length}{" "}
            {product.variations[0].detailedColor[0].text === "S"
               ? product.variations.length === 1
                  ? t("product.label.l1")
                  : t("product.label.l2")
               : product.variations.length === 1
               ? t("product.label.l3")
               : t("product.label.l4")}
         </Colors>
      </Container>
   )
}

Product.propTypes = {
   product: PropTypes.object,
   setIsMoving: PropTypes.func,
   endingPoint: PropTypes.object,
   index: PropTypes.number,
}

export default Product
